<div class="alias-question" *ngIf="items">
  <a class="alias-question__item" [href]="item.url" *ngFor="let item of items" [attr.aria-label]="item.title">
    {{ item.title }}
  </a>
</div>
